document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  // Menü öffnen
  menuToggle.addEventListener('click', () => {
    mobileMenu.classList.add('show');
    mobileMenu.setAttribute('aria-hidden', 'false');

    // Close Button nur einmal einfügen
    if (!mobileMenu.querySelector('.close-btn')) {
      const closeBtn = document.createElement('button');
      closeBtn.classList.add('close-btn');
      closeBtn.setAttribute('aria-label', 'Close menu');
      closeBtn.textContent = '×';
      closeBtn.addEventListener('click', () => {
        mobileMenu.classList.remove('show');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
      document.body.appendChild(closeBtn);
    }

    // Cart Link nur einmal einfügen
    if (!mobileMenu.querySelector('.mobile-menu-cart')) {
      const cartLink = document.createElement('a');
      cartLink.classList.add('mobile-menu-cart');
      cartLink.setAttribute('href', '/cart');
      cartLink.textContent = 'CART (0)';
      document.body.appendChild(cartLink);
    }
  });

  // Submenu toggles
  const submenuToggles = mobileMenu.querySelectorAll('.submenu-toggle');
  submenuToggles.forEach(button => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      const submenu = button.nextElementSibling;
      if (submenu) {
        submenu.classList.toggle('open');
        submenu.setAttribute('aria-hidden', String(expanded));
      }
    });
  });
});